export default __webpack_public_path__ + "23b6bb781f9c81a76865b6b670784010.png";